import { readPersistedSessionIds } from './sessionIds';
import { readUserPrefsDoc } from './userPrefs';

const LEGACY_K_USER_SETTINGS_KEY = 'KUserSettings';

export function defaultKUserSettings() {
    return {
        darkTheme: true,
        smallDraggableCards: false,
        dismissedHelps: {},
        planning: undefined,
        tabs: {
            screening: 'general',
            settings: 'customer',
        },
    };
}

/**
 * Prefer `kronos.user.*.v1` → `kUserSettings` when logged in; else legacy flat key.
 * @returns {object|null} Parsed settings object, or null if absent / invalid.
 */
export function readPersistedKUserSettingsObject() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return null;
    }
    try {
        const { userId } = readPersistedSessionIds();
        if (userId) {
            const doc = readUserPrefsDoc(userId);
            const ks = doc?.kUserSettings;
            if (ks && typeof ks === 'object') {
                return ks;
            }
        }
        /* Logged-in user may still have legacy flat storage until first `storeUserSettings`. */
        const raw = window.localStorage.getItem(LEGACY_K_USER_SETTINGS_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

/** Initial Redux `KUserSettings` shape (defaults + persisted overlay). */
export function readInitialKUserSettingsForReducer() {
    const persisted = readPersistedKUserSettingsObject();
    if (persisted) {
        const merged = { ...defaultKUserSettings(), ...persisted };
        if (!merged.dismissedHelps || typeof merged.dismissedHelps !== 'object') {
            merged.dismissedHelps = {};
        }
        return merged;
    }
    return defaultKUserSettings();
}
